export default __webpack_public_path__ + "static/media/aj1.31ff8846.jpeg";